// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
// import VideoPlayer from 'vue-video-player'
// import 'vue-video-player/src/custom-theme.css'
// import 'video.js/dist/video-js.css'

import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import './common/css/animate.min.css'

import 'element-ui/lib/theme-chalk/index.css'
import 'common/stylus/reset.styl'
import 'lib-flexible'

import router from './router'
import myMinix from './myMixin';
Vue.mixin(myMinix)

Vue.use(ElementUI)
// Vue.use(VideoPlayer)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js